<template>
  <div class="home">
    <div class="banner-box" id="home" ref="home">
      <menuBox></menuBox>
      <div class="banner-text">
        <div class="title">技術引領，服務至上</div>
        <div class="text">
          資訊諮詢/技術服務/廣告推廣
        </div>
      </div>
      <div class="menu-box">
        <span class="item active" @click="selectMenu(1)">
          首頁
        </span>
        <span class="item " @click="selectMenu(2)">
          關於我們
        </span>
        <span class="item" @click="selectMenu(3)">
          產品與服務
        </span>
        <span class="item " @click="selectMenu(4)">
          聯絡我們
        </span>
      </div>
    </div>
    <div class="waste-box">
      <div class="wasteOne">
        <img src="../assets/waste1.png" alt="">
        <div class="solidWaste">
          <div class="bt">Innovative Technology, Serving Future</div>
          <div class="fbt">創新科技，服務未來</div>
          <div class="line"></div>
          <div class="title">LEACHIDA TECH致力於科技創新和優質服務。 我們的核心業務涵蓋網路資訊諮詢、技術服務以及廣告推廣。 每項服務都是我們專業團隊的精心之作，旨在為客戶提供最先進的解決方案和卓越的使用者體驗。 加入我們，共創輝煌未來。</div>
        </div>
      </div>
      <div class="wasteTwo">
        <img src="../assets/waste2.png" alt="">
      </div>
      <div class="culture">
        <div class="line"></div>
        <div class="cultureTitle">企業文化內容</div>
      </div>
    </div>
    <div class="case-box">
      <div class="case-title">
        <p>Products&Services</p>
        <span>產品與服務</span>
      </div>
      <div class="listTop">
        <div class="list">
          <img class="case1" src="../assets/case1.png" alt="">
          <div class="list-title">
            <p>廣告分析系統</p>
            <span>(Advertising Analysis System)</span>
          </div>
        </div>
        <div class="list">
          <img class="case2" src="../assets/case2.png" alt="">
          <div class="list-title">
            <p>電子商務平台</p>
            <span>(E-Commerce Platform)</span>
          </div>
        </div>
      </div>
      <div class="listBottom">
        <div class="list">
          <img src="../assets/case3.png" alt="">
          <div class="list-title">
            <p>網路資訊諮詢服務</p>
            <span>(Internet Information Consulting Services)</span>
          </div>
        </div>
        <div class="list">
          <img src="../assets/case4.png" alt="">
          <div class="list-title">
            <p>技術服務與支援</p>
            <span>(Technical Services and Support)</span>
          </div>
        </div>
        <div class="list">
          <img style="margin-right: 0;" src="../assets/case5.png" alt="">
          <div class="list-title">
            <p>數位行銷與SEO優化</p>
            <span>(Digital Marketing and SEO Optimization)</span>
          </div>
        </div>
      </div>
    </div>
    <div class="news-box">
      <div class="news-title">
        <p>News</p>
        <span>新聞資訊</span>
      </div>
      <div class="news-content">
        <img src="../assets/newsInfo.png" alt="">
        <div class="right">
          <div class="newTop">
            <div class="item">
              <p>技術突破</p>
              <span>最新研發的網路安全解決方案成功上線，該技術提高了資料加密效率，同時降低了營運成本，引領業界安全標準的新高度，並得到業界專家的高度評價。</span>
            </div>
            <div class="item">
              <p>合作升級</p>
              <span>LEACHIDA TECH與國內外知名電商平台達成策略合作夥伴關係，雙方將在電子商務、大數據分析和雲端運算等領域進行深入合作，共同探索數位經濟的新機會</span>
            </div>
          </div>
          <div class="newBottom">
            <div class="item">
              <p>獲獎喜訊</p>
              <span>公司自主研發的廣告分析系統在國際科技創新大獎中獲得重要獎項，該系統憑藉其精準的市場分析和用戶洞察能力，被評為行業領先技術</span>
            </div>
            <div class="item">
              <p style="color: #fff;">擴張計劃</p>
              <span style="color: rgba(255,255,255,0.8);">LEACHIDA TECH宣布未來兩年將在亞洲和歐洲設立多個分支機構，以更好地服務全球客戶，該計劃預計將大幅提升公司的國際市場競爭</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footerBox></footerBox>
  </div>
</template>

<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";

export default {
  name: "App",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {};
  },
  mounted() {

  },
  methods: {
    selectMenu(value) {
      if (value == 1) {
        return;
      }
      switch (value) {
        case 1:
          this.$router.push({ path: "/" });
          break;
        case 2:
          this.$router.push({ path: "business" });
          break;
        case 3:
          this.$router.push({ path: "privacy" });
          break;
        case 4:
          this.$router.push({ path: "aboutUs" });
          break;
        default:
          this.$router.push({ path: "/" });
          break;
      }
    }
  },
};
</script>

<style lang="less" scoped>
.banner-box {
  background-image: url(../assets/swiper-1.png);
  height: 829px;
  background-size: 100% 100%;
  position: relative;

  .banner-text {
    padding: 189px 360px;
    width: 100%;
    box-sizing: border-box;
    text-align: center;

    .title {
      margin-bottom: 60px;
      font-size: 68px;
      font-family: PingFang HK, PingFang HK;
      font-weight: 600;
      color: #FFFFFF;
    }

    .text {
      font-size: 26px;
      font-family: PingFang HK, PingFang HK;
      font-weight: 300;
      color: #FFFFFF;
      letter-spacing: 10px;
    }
  }

  .menu-box {
    position: absolute;
    left: 360px;
    bottom: 40px;

    .item {
      cursor: pointer;
      padding: 24px 28px;
      font-size: 18px;
      font-family: PingFang TC, PingFang TC;
      font-weight: 400;
      color: #FFFFFF;
    }

    .active {
      border-top: 4px solid #DA1C1F;
      color: #DA1C1F;
    }
  }
}

.waste-box {
  position: relative;
  margin: 192px 360px 0;

  .wasteOne {
    position: relative;

    img {
      width: 854px;
      height: 569px;
    }

    .solidWaste {
      position: absolute;
      top: 8px;
      left: 0;
      max-width: 700px;

      .bt {
        margin-bottom: 10px;
        font-size: 18px;
        font-family: PingFang HK, PingFang HK;
        font-weight: 600;
        color: #333333;
      }

      .fbt {
        margin-bottom: 49px;
        font-size: 38px;
        font-family: PingFang HK, PingFang HK;
        font-weight: 600;
        color: #333333;
      }

      .line {
        margin-bottom: 66px;
        width: 40px;
        height: 6px;
        background: #DA1C1F;
      }

      .title {
        font-size: 18px;
        font-family: PingFang HK, PingFang HK;
        font-weight: 500;
        color: #333333;
      }
    }
  }

  .wasteTwo {
    position: absolute;
    top: -46px;
    right: 0;

    img {
      width: 466px;
      height: 443px;
    }
  }

  .culture {
    position: absolute;
    bottom: 89px;
    right: 8px;
    display: flex;
    align-items: center;

    .line {
      margin-right: 56px;
      width: 245px;
      height: 4px;
      background: #DA1C1F;
    }

    .cultureTitle {
      font-size: 26px;
      font-family: PingFang HK, PingFang HK;
      font-weight: 600;
      color: #333333;
    }
  }
}

.case-box {
  padding: 117px 360px 0;
  box-sizing: border-box;

  .case-title {
    margin-bottom: 80px;
    text-align: center;

    p {
      margin-bottom: 4px;
      font-size: 18px;
      font-family: PingFang HK, PingFang HK;
      font-weight: 600;
      color: #333333;
    }

    span {
      display: block;
      font-size: 38px;
      font-family: PingFang HK, PingFang HK;
      font-weight: 600;
      color: #333333;
    }
  }

  .listTop {
    display: flex;

    .list {
      position: relative;



      .case1 {
        margin-right: 22px;
        width: 782px;
        height: 340px;
      }

      .case2 {
        width: 380px;
        height: 340px;
      }
    }
  }

  .listBottom {
    display: flex;

    .list {
      position: relative;

      img {
        margin-right: 22px;
        width: 380px;
        height: 340px;
      }
    }
  }

  .list-title {
    position: absolute;
    top: 60px;
    left: 40px;

    p {
      margin-bottom: 10px;
      font-size: 26px;
      font-family: PingFang HK, PingFang HK;
      font-weight: 500;
      color: #FFFFFF;
      letter-spacing: 2px;
    }

    span {
      font-size: 16px;
      font-family: PingFang HK, PingFang HK;
      font-weight: 500;
      color: #FFFFFF;
    }
  }
}

.news-box {
  padding: 150px 360px;
  box-sizing: border-box;

  .news-title {
    margin-bottom: 80px;
    text-align: center;

    p {
      margin-bottom: 4px;
      font-size: 18px;
      font-family: PingFang HK, PingFang HK;
      font-weight: 600;
      color: #333333;
    }

    span {
      display: block;
      font-size: 38px;
      font-family: PingFang HK, PingFang HK;
      font-weight: 600;
      color: #333333;
    }
  }

  .news-content {
    display: flex;

    img {
      float: left;
      margin-right: 20px;
      width: 450px;
      height: 665px;
    }

    .right {
      .newTop {
        display: flex;
        align-items: center;
      }

      .newBottom {
        display: flex;
        align-items: center;

        .item {
          margin-bottom: 0;
        }

        .item:nth-child(2) {
          background-color: #DA1C1F;
        }
      }

      .item {
        padding: 34px 33px;
        margin: 0 18px 23px 0;
        width: 348px;
        height: 320px;
        background-color: #F6F6F6;
        box-sizing: border-box;

        p {
          margin-bottom: 26px;
          font-size: 24px;
          font-family: PingFang HK, PingFang HK;
          font-weight: 500;
          color: #333333;
        }

        span {
          font-size: 20px;
          font-family: PingFang HK, PingFang HK;
          font-weight: 400;
          color: rgba(51, 51, 51, 0.8);
        }
      }

      .item:nth-child(2n) {
        margin-right: 0;
      }
    }
  }
}
</style>
